<!--
 * @Author: your name
 * @Date: 2020-12-11 11:15:25
 * @LastEditTime: 2022-12-07 10:50:33
 * @LastEditors: 逐梦的风很轻 1114532270@qq.com
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/views/tab-admin/tab-payment-info/index.vue
-->
<style scoped lang="sass">
$color: var(--menu-primary-text-colour)

.payment_container
  display: flex
  flex-direction: column
  padding: 28px 17px 60px
  margin-bottom: 20px

.footer_common
  position: fixed
  bottom: 0
  left: 0

.top_info
  margin-bottom: 20px

.title
  margin-bottom: 20px
  line-height: 20px
  font-size: 17px
  color: $color
  text-align: center

.info
  font-size: 13px
  line-height: 17px
  color: $color
  text-align: center

.sub_info
  font-size: 13px
  line-height: 17px
  color: $color
  text-align: center

.icon
  margin: 0
  margin-bottom: 10px

.time,
.expire
  display: flex
  justify-content: space-between

.expire
  margin-right: 30px
  flex: 1

.cvv
  flex: 1

.time,
.credit_card
  margin-top: 20px

.left_part
  color: var(--menu-primary-background-colour)

.month
  margin-right: 20px

div[placeholder="YY"]
  ::v-deep
    label
      margin-left: -20PX

::v-deep
  .van-button--primary
    background-color: var(--menu-primary-background-colour)
</style>

<style lang="sass" scoped>
.card_expiry
  position: relative
  display: flex
  justify-content: space-between

.expiry
  width: 35%

.cvv
  width: 50%

.ios_expiry
  flex: 1
  margin-right: 20px

.card-wrapper
  display: none
</style>

<template lang="pug">
.payment_container
  .top_info
    .title.b {{ title }}
    .info.o6 {{ content }}
    .sub_info.b.o8 {{ subInfo }}
  .payment_info
    small-icon.icon(icon='credit_card')
    .card-wrapper
    py-form.form(
      ref="form"
      :model="tabPayment"
      :rules="ruleValidate"
    )
      .name
        py-form-item.first_name(prop='name')
          py-input(
            v-model="tabPayment.name"
            name="first-name"
            title="Name on card"
            type="text"
            :disabled="disabledPaymentInput"
          )
      .card_number
        py-form-item.first_name(prop='cardNumber')
          py-input(
            v-model="tabPayment.cardNumber"
            name="number"
            title="Card Number"
            type="text"
            :disabled="disabledPaymentInput"
          )
      .card_expiry
        py-form-item.expiry(
          prop='cardExpiry'
          :class="{'ios_expiry': true}"
        )
          expire-date-input(
            v-if="!isIOS"
            v-model="tabPayment.cardExpiry"
            :disabled="disabledPaymentInput"
          )
          py-input(
            v-else
            name="expiry"
            v-model="tabPayment.cardExpiry"
            title="Expiry (MM / YY)"
            maxlength="7"
            type="number"
            :disabled="disabledPaymentInput"
          )
        py-form-item.cvv(prop='cvc')
          py-input(
            id="cvv"
            name="cvc"
            v-model="tabPayment.cvc"
            title="CVV"
            type="number"
            :disabled="disabledPaymentInput"
          )
  footer-bar.footer_common.b(
    v-if="hasToken"
    :status="status"
    :isButton="true"
    @clickButton="handleSubmit"
  )
    template(v-slot:left v-if="")
      .left_part(@click="enablePaymentInput")
        span Change Details
  footer-common.footer_common.b(
    v-else
    :text="text"
    @clickButton="handleSubmit"
  )
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import SmallIcon from 'components/SmallIcon'
import InputField from '../../components/input-field'
import CreditCardInput from '../../components/CreditCardInput'
import { emitLoading } from 'utils/decorators'
import { updateTab } from 'api/tab'
import { tab_insufficient_fund_payment } from 'utils/message'
import { isIOS } from '@/utils/navigator'
import { t } from '@/utils/language'
import { formatDecimalNumber } from '@/utils/currency'
import Card from 'card'

import { _setFormatDate, _setFormatTime, } from 'utils/format'

import ExpireDateInput from 'components/ExpireDateInput'

@Component({
  components: {
    SmallIcon,
    InputField,
    CreditCardInput,
    ExpireDateInput
  },

  props: {
    venueId: {
      type: String
    },

    tabId: {
      type: [String, Number]
    },

    tabPayment: {
      type: Object
    },

    tabInfo: {
      type: Object
    },

    oldPaymentDetail: {
      type: Object
    },

    disabledPaymentInput: {
      type: Boolean
    },

    hasToken: {
      type: Boolean
    }
  },

  computed: {
    content() {
      return `Note that a pre-authorisation will be placed on your card for $${formatDecimalNumber(parseFloat(this.tabInfo.tabAmount))} to ensure there are sufficient funds on the card.`
    },

    tabData() {
      return {
        tabId: this.tabId,
        venueId: this.venueId,
        // @todo getData from store
        passCode: localStorage.getItem('tabPassCode'),
        action: 'update',
        detail: this.tabInfo
      }
    },
  },

  mounted() {
    this.$nextTick(_ => {
      // https://github.com/jessepollak/card
      var card = new Card({
        form: 'form',
        container: '.card-wrapper',
      })
    })
  }
})

class TabPaymentInfo extends Vue {
  t(key, fallback) {
    const _lang = this.$lang // eslint-disable-line no-unused-vars
    return t(key, fallback)
  }

  isIOS = isIOS()

  ruleValidate = {
    cardNumber: [
      { required: true, message: 'Card number is required', trigger: 'blur' },
      { validator: this._validateCardNum, trigger: 'blur' },
    ],
    name: [
      { required: true, message: 'First name is required', trigger: 'blur' },
    ],
    cardLastName: [
      { required: true, message: 'Last name is required', trigger: 'blur' },
      { validator: this._validateCardNum, trigger: 'blur' },
    ],
    cardExpiry: [
      { required: true, message: 'Expiry is required', trigger: 'blur' },
      { validator: this._validateDate, trigger: 'blur' },
    ],
    cvc: [
      { required: true, message: 'CVV is required', trigger: 'blur' },
      { validator: this._validateCvv, trigger: 'blur' },
    ],
  }

  status = 6
  showTabDialog = false
  title = 'Your payment details'
  subInfo = 'You will not be charged until the tab is closed.'
  text = t('submit', 'SUBMIT')
  valueFields = {
    name: '',
    cardNum: '',
    expiryData: '',
    cvv: ''
  }

  _validateCardNum(rule, value, callback) {
    const cardNum = value.replace(/\s+/g, '')
    console.log({
      cardNum: value
    })
    if (value.length === 19) {
      callback()
    } else if (value.length === 16 && !value.trim().includes(' ')) {
      callback()
    } else if (cardNum.length === 15) {
      callback()
    } else {
      callback(new Error('Incorrect card number. Please re-enter'))
    }
  }

  _validateDate(rule, value, callback) {
    if (this.isIOS) {
      if (value.length < 7) {
        return callback(new Error('Format of expiry is incorrect'))
      }
    }
    const [getMonth, getYear] = value.split('/')
    const month = getMonth.trim()
    const year = getYear.trim()

    // 失败条件
    // console.log(this.creditCardYearValidateFirstTime)
    if (!month) return callback(new Error('Expiry month is required'))
    if (!year && !this.creditCardYearValidateFirstTime) return callback(new Error('Expiry year is required'))
    this.creditCardYearValidateFirstTime = false

    if (parseInt(month) === 0 || parseInt(month) > 12) {
      return callback(new Error('Invaild Month'))
    }
    if (parseInt(year) === 0) {
      return callback(new Error('Invaild Year'))
    }
    return callback()
  }

  _validateCvv(rule, value, callback) {
    if (value.length < 3) {
      callback(new Error('Cvv is not correct'))
    }
    callback()
  }

  enablePaymentInput() {
    this.$emit('enablePaymentInput')
  }

  validateYear(val) {
    if (parseInt(val) === 0) return false
    return true
  }

  validateMonth(val) {
    if ((parseInt(val) === 0) || (parseInt(val) > 12)) return false
    return true
  }

  @emitLoading('input')
  async handleSubmit() {
    try {
      // Card on file and the customer did not press "Change Details": the fields are locked and the
      // backend no longer returns the CVC, so the CVV rule cannot pass and must not run — the saved
      // card is kept as is. Once "Change Details" unlocks the fields, a new card is validated in full.
      if (!this.disabledPaymentInput) {
        const res = await this.$refs.form.validate()
        if (!res) return
      }
      await this._updateTab()
      this.jumpToMenu()
    } catch (error) {
      if (error === 'tab_insufficient_fund') {
        this.$createTabMessageDialog({
          $props: tab_insufficient_fund_payment,
        }).show()
      }
      this.closeLoading()
    }
  }

  async _updateTab() {
    const nowPaymentDetail = { ...this.tabInfo.paymentDetail }
    const { token, ...delTokenPaymentDetail } = nowPaymentDetail
    const tabData = JSON.parse(JSON.stringify({
      ...this.tabData,
      detail: {
        name: this.tabData.detail.name,
        phone: this.tabData.detail.phone,
        email: this.tabData.detail.email,
        openDateTime: {
          date: _setFormatDate(this.tabData.detail.openDateTime.date),
          time: _setFormatTime(this.tabData.detail.openDateTime.time),
        },
        minAmount: this.tabData.detail.minAmount,
        tabAmount: parseInt(this.tabData.detail.tabAmount),
        paymentDetail: {
          ...delTokenPaymentDetail,
          // '' when the card on file is kept (the backend does not store or return the CVC)
          cvc: delTokenPaymentDetail.cvc || '',
          expireMonth: delTokenPaymentDetail.cardExpiry.split(' / ')[0],
          expireYear: delTokenPaymentDetail.cardExpiry.split(' / ')[1],
        }
      }
    }))
    const oldPaymentDetail = { ...this.oldPaymentDetail }
    if (oldPaymentDetail.cardNumber === nowPaymentDetail.cardNumber) {
      if (oldPaymentDetail.token) tabData.detail.paymentDetail.token = oldPaymentDetail.token
    } else {
      delete tabData.detail?.paymentDetail?.token
    }
    await updateTab(tabData)
  }

  closeLoading() {
    this.$emit('input', false)
  }

  jumpToMenu() {
    const query = {}
    if (this.tabInfo.userId) {
      query.isTabReady = 1
    }
    this.$router.push({
      path: `/v/${this.venueId}/tab-admin/${this.tabId}/menu`,
      query: query
    })
  }
}

export default TabPaymentInfo
</script>
